import { ModuleValueUniversal, SchemaModuleUniversal } from './module-universal';
import { JSONSchema } from '../types/json-schema';
import { FormComponent } from '../form.component';
import { Validator, FormProperty, PropertyGroup } from '../angular2-schema-form-shim';

import * as rawJSONSchemaModuleUpperGiSurgery from '../../schemas/module-upper-gi-surgery.json';

export class SchemaModuleUpperGiSurgery extends SchemaModuleUniversal {
  schema: JSONSchema<ModuleValueUniversal>;

  constructor() {
    super();

    this.loadSchema( rawJSONSchemaModuleUpperGiSurgery );
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-upper-gi-surgery.ts